export default __webpack_public_path__ + "static/media/IconEmail.c5a7bcbe.svg";